import { Type } from './types/Type';
import { IStringDictionary } from './base/common/collections';

export class TypeScope {
  /** @constructor */
  names: IStringDictionary<Type> = {};
  constructor() {
    // map from names to type objects.
    // this.names = {};
  }
}
